// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3krf4","choiceBoxes":"toolbarselects_choiceBoxes__1GNLY","simpleField":"toolbarselects_simpleField__QuigD"};